<template>
  <div class="form-group-simple"
  :class="{
    'form-group-simple--completed': completed,
    'form-group-simple--error': error,
    'form-group-simple--alt': alt }">
    <label :for="inputid" v-if="label !== ''">{{ label }}</label>
    <input v-if="type === 'text'" type="text"              ref="input" :name="inputid" v-model="value" :id="inputid" :placeholder="placeholder" :maxlength="maxlength" v-on:blur="blur" :disabled="disabled" v-on:input="input" :autofocus="autofocus">
    <input v-else-if="type === 'email'" type="email"       ref="input" :name="inputid" v-model="value" :id="inputid" :placeholder="placeholder" :maxlength="maxlength" v-on:blur="blur" :autofocus="autofocus">
    <input v-else-if="type === 'number'" type="number"     ref="input" :name="inputid" v-model="value" :id="inputid" :placeholder="placeholder" :maxlength="maxlength" v-on:blur="blur" :autofocus="autofocus">
    <input v-else-if="type === 'password'" type="password" ref="input" :name="inputid" v-model="value" :id="inputid" :placeholder="placeholder" :maxlength="maxlength" v-on:blur="blur" :autofocus="autofocus">
    <input v-else-if="type === 'url'" type="url"           ref="input" :name="inputid" v-model="value" :id="inputid" :placeholder="placeholder" :maxlength="maxlength" v-on:blur="blur" :autofocus="autofocus">
    <input v-else-if="type === 'tel'" type="tel"           ref="input" :name="inputid" v-model="value" :id="inputid" :placeholder="placeholder" :maxlength="maxlength" v-on:blur="blur" :autofocus="autofocus">
     <div class="input-group-append" v-if="showAppend">
      <div class="input-group-text">{{ appendText }}</div>
    </div>
    <div class="form-group-simple__details" v-if="error">
      <div class="form-group-simple__messages">
        <div class="form-group-simple__error" v-if="errorMessage">{{ errorMessage }}</div>
        <div class="form-group-simple__error" v-else>* Dit veld is verplicht.</div>
      </div>
    </div>
  </div>
</template>

<script>
// import { Validator } from 'vee-validate'

export default {
  name: 'v-input-group-simple',
  validator: null,
  props: {
    autofocus: {
      default: false,
      type: Boolean
    },
    label: {
      default: '',
      type: String
    },
    alt: {
      default: false,
      type: Boolean
    },
    initvalue: {
      default: '',
      type: String
    },
    type: {
      default: 'text',
      type: String
    },
    inputid: {
      default: 'inputid',
      type: String
    },
    placeholder: {
      default: '',
      type: String
    },
    disabled: {
      default: false,
      type: Boolean
    },
    overwriteValue: [String, null],
    error: {
      default: false,
      type: Boolean
    },
    errorMessage: {
      default: 'Error',
      type: String
    },
    maxlength: {
      default: '',
      type: String
    },
    inputEvent: {
      default: true,
      type: Boolean
    },
    showAppend: {
      default: false,
      type: Boolean
    },
    appendText: {
      default: '',
      type: String
    }
  },
  data () {
    return {
      search: '',
      errors: '',
      testDate: '01-01-2018',
      completed: false,
      value: this.initvalue
    }
  },
  watch: {
    overwriteValue (value) {
      if (value != null) {
        this.value = value
      }
    }
  },
  methods: {
    blur () {
      if (this.value.length > 0) {
        this.completed = true
      }
      this.$emit('blur', this.inputid, this.value)
    },
    getValue () {
      return this.$refs.input.value
    },
    input (event) {
      if (!this.inputEvent) {
        return
      }
      this.$emit('input', event.target.id, event.target.value)
    }
  }
}
</script>
<style lang="scss" scoped>
.form-group-simple {
  position: relative;
  .input-group-append {
    position: absolute;
    display: flex;
    right: 0;
    top: 32px;
  }
  .input-group-text {
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    padding: .375rem .75rem;
    margin-bottom: 0;
    font-weight: 400;
    line-height: 1.5;
    color: #495057;
    text-align: center;
    white-space: nowrap;
    background-color: #e9ecef;
    border: 1px solid #ced4da;
    border-radius: 0 .25rem .25rem 0;
    height: 50px;
  }
}
</style>
